// // --- components/RevenueChart.jsx ---
// import {
//   ResponsiveContainer,
//   AreaChart,
//   Area,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
// } from "recharts";

// export default function Linechart({ revenueTrends }) {
//   const chartData = revenueTrends || [];

//   return (
//     <div className="h-auto w-full space-y-4">
//       <div className="h-60 bg-white shadow rounded-xl p-2">
//         <ResponsiveContainer>
//           <AreaChart
//             data={chartData}
//             margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
//           >
//             <defs>
//               <linearGradient id="smoothGradient" x1="0" y1="0" x2="0" y2="1">
//                 <stop offset="0%" stopColor="#3383B2" stopOpacity={0.4} />
//                 <stop offset="100%" stopColor="#3383B2" stopOpacity={0} />
//               </linearGradient>
//             </defs>

//             <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5f3fa" />
//             <XAxis
//               dataKey="name"
//               tick={{ fill: "#4A5568", fontSize: 11 }}
//               axisLine={false}
//               tickLine={false}
//             />
//             <YAxis
//               tick={{ fill: "#4A5568", fontSize: 11 }}
//               axisLine={false}
//               tickLine={false}
//             />
//             <Tooltip
//               contentStyle={{
//                 backgroundColor: "#fff",
//                 border: "1px solid #e2e8f0",
//                 borderRadius: "6px",
//                 fontSize: "12px",
//               }}
//             />
//             <Area
//               type="monotone"
//               dataKey="value"
//               stroke="#3383B2"
//               fill="url(#smoothGradient)"
//               strokeWidth={2}
//               dot={false}
//               isAnimationActive
//             />
//           </AreaChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// }


import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

export default function RevenueChart({ revenueTrends }) {
  const data = revenueTrends || [];

  return (
    <div className="h-auto w-full">
      <div className="h-80 p-2">
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="seeThroughDarkBlue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#3383B2" stopOpacity={0.7} />
                <stop offset="100%" stopColor="#3383B2" stopOpacity={0.7} />
              </linearGradient>
            </defs>

            <CartesianGrid 
              strokeDasharray="4 4"      
              stroke="#CBD5E0"           
              strokeWidth={1.1}          
             
            />
            <XAxis
              dataKey="name"
              tick={{ fill: "#2D3748", fontSize: 12, fontWeight: 500 }}
              axisLine={{ stroke: "#A0AEC0", strokeWidth: 1.5 }} 
              tickLine={{ stroke: "#A0AEC0", strokeWidth: 1 }}   
            />
            <YAxis
              tick={{ fill: "#2D3748", fontSize: 12, fontWeight: 500 }}
              axisLine={{ stroke: "#A0AEC0", strokeWidth: 1.5 }}
              tickLine={{ stroke: "#A0AEC0", strokeWidth: 1 }}   
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: "6px",
                fontSize: "12px",
              }}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#3383B2"
              fill="url(#seeThroughDarkBlue)"
              strokeWidth={2}
              dot={false}
              isAnimationActive
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}



